module.exports = __webpack_public_path__ + "1.5.0-unryo/img/ms-iis.c9e35a8d.png";